import { render, staticRenderFns } from "./ContactConfirmSwitch.vue?vue&type=template&id=62c1e75a&scoped=true&lang=pug"
import script from "./ContactConfirmSwitch.vue?vue&type=script&lang=ts"
export * from "./ContactConfirmSwitch.vue?vue&type=script&lang=ts"
import style0 from "./ContactConfirmSwitch.vue?vue&type=style&index=0&id=62c1e75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c1e75a",
  null
  
)

export default component.exports